import { Goal, GoalType } from '@griply/types';

// Firestore accepts children on a project; only the clients keep projects leaves.
export const canGoalHaveChildren = (
  goal: Pick<Goal, 'type'> | undefined | null,
): boolean => goal?.type !== GoalType.Project;
